import { useContext } from 'react'
import { AuthContextProps, AuthContext } from '../contexts/auth/AuthContext'

const useAuth = () => {
  return useContext(AuthContext) as AuthContextProps
}

export default useAuth
